var map = {
	"./allocate.svg": 43729,
	"./archive.svg": 90733,
	"./arrow-down.svg": 38239,
	"./arrow-left.svg": 94027,
	"./arrow-right.svg": 37807,
	"./arrow-up.svg": 38200,
	"./bookmark.svg": 40702,
	"./calendar.svg": 78593,
	"./cancel.svg": 24032,
	"./caret-down.svg": 27463,
	"./caret-left.svg": 66835,
	"./caret-right.svg": 26077,
	"./caret-up.svg": 60436,
	"./cart.svg": 72158,
	"./check-circle.svg": 21686,
	"./check-in.svg": 23316,
	"./check-out.svg": 67422,
	"./chevron-double-left.svg": 34927,
	"./chevron-double-right.svg": 75091,
	"./chevron-left.svg": 40839,
	"./chevron-right.svg": 86181,
	"./clipboard.svg": 27640,
	"./clock.svg": 47369,
	"./combine.svg": 190,
	"./comment.svg": 95073,
	"./dash.svg": 7204,
	"./default.svg": 35422,
	"./deselect-all.svg": 70825,
	"./diacritic.svg": 13609,
	"./document.svg": 31968,
	"./download.svg": 50280,
	"./drag-drop.svg": 83786,
	"./duplicate.svg": 96289,
	"./edit.svg": 44559,
	"./ellipsis.svg": 86056,
	"./end-mark.svg": 9432,
	"./envelope.svg": 49705,
	"./exclamation-circle.svg": 70648,
	"./external-link.svg": 66294,
	"./eye-closed.svg": 29034,
	"./eye-open.svg": 52026,
	"./flag.svg": 13854,
	"./gear.svg": 23749,
	"./graph.svg": 7135,
	"./house.svg": 97809,
	"./indexes.svg": 23756,
	"./info.svg": 31974,
	"./lightning.svg": 56282,
	"./link.svg": 56971,
	"./list.svg": 47739,
	"./lock.svg": 34913,
	"./play.svg": 28633,
	"./plus-sign.svg": 14202,
	"./preview.svg": 16405,
	"./print.svg": 75219,
	"./profile.svg": 3373,
	"./question-mark.svg": 64333,
	"./receive.svg": 83630,
	"./refresh.svg": 93777,
	"./replace.svg": 26075,
	"./report.svg": 51094,
	"./save.svg": 59592,
	"./search.svg": 89527,
	"./select-all.svg": 31065,
	"./source.svg": 25782,
	"./tag.svg": 81891,
	"./times-circle-solid.svg": 8031,
	"./times-circle.svg": 96542,
	"./times.svg": 42164,
	"./transfer.svg": 38528,
	"./trash.svg": 53727,
	"./triangle-down.svg": 59229,
	"./triangle-up.svg": 77895,
	"./unlink.svg": 87830,
	"@folio/stripes-components/lib/Icon/icons/allocate.svg": 43729,
	"@folio/stripes-components/lib/Icon/icons/archive.svg": 90733,
	"@folio/stripes-components/lib/Icon/icons/arrow-down.svg": 38239,
	"@folio/stripes-components/lib/Icon/icons/arrow-left.svg": 94027,
	"@folio/stripes-components/lib/Icon/icons/arrow-right.svg": 37807,
	"@folio/stripes-components/lib/Icon/icons/arrow-up.svg": 38200,
	"@folio/stripes-components/lib/Icon/icons/bookmark.svg": 40702,
	"@folio/stripes-components/lib/Icon/icons/calendar.svg": 78593,
	"@folio/stripes-components/lib/Icon/icons/cancel.svg": 24032,
	"@folio/stripes-components/lib/Icon/icons/caret-down.svg": 27463,
	"@folio/stripes-components/lib/Icon/icons/caret-left.svg": 66835,
	"@folio/stripes-components/lib/Icon/icons/caret-right.svg": 26077,
	"@folio/stripes-components/lib/Icon/icons/caret-up.svg": 60436,
	"@folio/stripes-components/lib/Icon/icons/cart.svg": 72158,
	"@folio/stripes-components/lib/Icon/icons/check-circle.svg": 21686,
	"@folio/stripes-components/lib/Icon/icons/check-in.svg": 23316,
	"@folio/stripes-components/lib/Icon/icons/check-out.svg": 67422,
	"@folio/stripes-components/lib/Icon/icons/chevron-double-left.svg": 34927,
	"@folio/stripes-components/lib/Icon/icons/chevron-double-right.svg": 75091,
	"@folio/stripes-components/lib/Icon/icons/chevron-left.svg": 40839,
	"@folio/stripes-components/lib/Icon/icons/chevron-right.svg": 86181,
	"@folio/stripes-components/lib/Icon/icons/clipboard.svg": 27640,
	"@folio/stripes-components/lib/Icon/icons/clock.svg": 47369,
	"@folio/stripes-components/lib/Icon/icons/combine.svg": 190,
	"@folio/stripes-components/lib/Icon/icons/comment.svg": 95073,
	"@folio/stripes-components/lib/Icon/icons/dash.svg": 7204,
	"@folio/stripes-components/lib/Icon/icons/default.svg": 35422,
	"@folio/stripes-components/lib/Icon/icons/deselect-all.svg": 70825,
	"@folio/stripes-components/lib/Icon/icons/diacritic.svg": 13609,
	"@folio/stripes-components/lib/Icon/icons/document.svg": 31968,
	"@folio/stripes-components/lib/Icon/icons/download.svg": 50280,
	"@folio/stripes-components/lib/Icon/icons/drag-drop.svg": 83786,
	"@folio/stripes-components/lib/Icon/icons/duplicate.svg": 96289,
	"@folio/stripes-components/lib/Icon/icons/edit.svg": 44559,
	"@folio/stripes-components/lib/Icon/icons/ellipsis.svg": 86056,
	"@folio/stripes-components/lib/Icon/icons/end-mark.svg": 9432,
	"@folio/stripes-components/lib/Icon/icons/envelope.svg": 49705,
	"@folio/stripes-components/lib/Icon/icons/exclamation-circle.svg": 70648,
	"@folio/stripes-components/lib/Icon/icons/external-link.svg": 66294,
	"@folio/stripes-components/lib/Icon/icons/eye-closed.svg": 29034,
	"@folio/stripes-components/lib/Icon/icons/eye-open.svg": 52026,
	"@folio/stripes-components/lib/Icon/icons/flag.svg": 13854,
	"@folio/stripes-components/lib/Icon/icons/gear.svg": 23749,
	"@folio/stripes-components/lib/Icon/icons/graph.svg": 7135,
	"@folio/stripes-components/lib/Icon/icons/house.svg": 97809,
	"@folio/stripes-components/lib/Icon/icons/indexes.svg": 23756,
	"@folio/stripes-components/lib/Icon/icons/info.svg": 31974,
	"@folio/stripes-components/lib/Icon/icons/lightning.svg": 56282,
	"@folio/stripes-components/lib/Icon/icons/link.svg": 56971,
	"@folio/stripes-components/lib/Icon/icons/list.svg": 47739,
	"@folio/stripes-components/lib/Icon/icons/lock.svg": 34913,
	"@folio/stripes-components/lib/Icon/icons/play.svg": 28633,
	"@folio/stripes-components/lib/Icon/icons/plus-sign.svg": 14202,
	"@folio/stripes-components/lib/Icon/icons/preview.svg": 16405,
	"@folio/stripes-components/lib/Icon/icons/print.svg": 75219,
	"@folio/stripes-components/lib/Icon/icons/profile.svg": 3373,
	"@folio/stripes-components/lib/Icon/icons/question-mark.svg": 64333,
	"@folio/stripes-components/lib/Icon/icons/receive.svg": 83630,
	"@folio/stripes-components/lib/Icon/icons/refresh.svg": 93777,
	"@folio/stripes-components/lib/Icon/icons/replace.svg": 26075,
	"@folio/stripes-components/lib/Icon/icons/report.svg": 51094,
	"@folio/stripes-components/lib/Icon/icons/save.svg": 59592,
	"@folio/stripes-components/lib/Icon/icons/search.svg": 89527,
	"@folio/stripes-components/lib/Icon/icons/select-all.svg": 31065,
	"@folio/stripes-components/lib/Icon/icons/source.svg": 25782,
	"@folio/stripes-components/lib/Icon/icons/tag.svg": 81891,
	"@folio/stripes-components/lib/Icon/icons/times-circle-solid.svg": 8031,
	"@folio/stripes-components/lib/Icon/icons/times-circle.svg": 96542,
	"@folio/stripes-components/lib/Icon/icons/times.svg": 42164,
	"@folio/stripes-components/lib/Icon/icons/transfer.svg": 38528,
	"@folio/stripes-components/lib/Icon/icons/trash.svg": 53727,
	"@folio/stripes-components/lib/Icon/icons/triangle-down.svg": 59229,
	"@folio/stripes-components/lib/Icon/icons/triangle-up.svg": 77895,
	"@folio/stripes-components/lib/Icon/icons/unlink.svg": 87830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23559;